module.exports = __webpack_public_path__ + "static/Li-Ion-Battery-Pack-3-97493a31cf1fe30bd89beb38f7659fbe.jpg";